<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-layout v-on="on">
        <v-flex class="name-style">{{ name }}</v-flex>
      </v-layout>
    </template>
    <span>{{ name }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'IntervalReportListName',
  props: {
    name: {
      type: String,
      default: null,
    },
  },
}
</script>

<style scoped>
.name-style {
  flex: 1;
  max-width: 260px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
